import api from './api';

export const createPayment = async (amount) => {
  const { data } = await api.post('/users/me/payments/create', { amount });
  return data;
};

export const checkPaymentStatus = async (paymentId) => {
  const { data } = await api.get(`/users/me/payments/${paymentId}`);
  return data;
};

export const getPayments = async () => {
  const { data } = await api.get('/users/me/payments');
  return data;
};

export const cancelPayment = async (paymentId) => {
  const { data } = await api.post(`/users/me/payments/${paymentId}/cancel`);
  return data;
};
